module.exports = __webpack_public_path__ + "static/media/dr-douse-old.c258f55e.jpg";